import { Tooltip } from '@mui/material';
import { useRouter } from 'next/router';
import { pickStringWithLocale } from '../utils/pickStringWithLocale';
import Image from 'next/image';

export const CategoryIconsRow = ({ company }) => {
  const { locale } = useRouter();

  return (
    <>
      {company.company.productAbilityCategories.map((i) => {
        return (
          <Tooltip key={i.id} title={pickStringWithLocale(locale, 'name', i)}>
            <Image
              src={i.icon.url}
              width={20}
              height={20}
              alt={pickStringWithLocale(locale, 'name', i)}
            />
          </Tooltip>
        );
      })}
    </>
  );
};
